module.exports = __webpack_public_path__ + "static/img/m_role.1277c8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/kr/m_role.png
// module id = AFgK
// module chunks = 7